import cn from "classnames"
import React from "react"

import { CaseButton } from "~/components/CaseButton/CaseButton"
import { Lead } from "~/components/Helpers/Lead/Lead"
import { SliderWrapper } from "~/components/Slider/Slider"

import styles from "./index.module.css"

const Caption = ({ slug, logo, title, active, caseUrl, readyMagMobile }) => (
  <div className={styles.Caption} data-js="slider__caption" data-state={active ? "active" : null}>
    <CaseButton caseUrl={caseUrl} slug={slug}>
      {logo && (
        <div className={cn(styles.CaptionLogo, { [styles.CaptionLogoReadyMag]: readyMagMobile })}>
          <img src={logo} />
        </div>
      )}
      <Lead className={styles.CaptionText}>{title}</Lead>
    </CaseButton>
  </div>
)

export const ProjectsSlider = ({ related, maxHeight, readyMagMobile }) => {
  related = related.filter((item) => item.isPublished)
  if (!related || related === 0) {
    return null
  }

  const isMany = related.length > 1

  const onInit = (swiper) => {
    const toggleCaption = () => {
      const { activeIndex, previousIndex } = swiper
      const direction = activeIndex < previousIndex ? "left" : "right"

      swiper.slides.each((i, el) => {
        const caption = el.querySelector("[data-js=slider__caption]")
        const state = i === activeIndex ? direction : null
        caption.dataset.state = state

        if (state) {
          setTimeout(() => (caption.dataset.state = "active"), 400)
        }
      })
    }

    swiper.on("slideChangeTransitionStart", toggleCaption)
  }

  return (
    <SliderWrapper
      className={styles.Wrapper}
      containerClassName={styles.Container}
      isMany={isMany}
      params={{ speed: 600 }}
      slides={() =>
        related.map(({ slug, image, badge, client, shortTitle, link }, i) => {
          const logo = client?.image?.LogoTrim

          return (
            <SliderWrapper.Slide key={image.ImageWideLarge} isMany={isMany}>
              <div className={styles.Slide} data-max-height={maxHeight}>
                <CaseButton caseUrl={link} className={styles.Image} slug={slug}>
                  <SliderWrapper.Image
                    className={styles.ImageWrapper}
                    data-max-height={maxHeight}
                    image={image.ImageWideLarge}
                    isMany={isMany}
                    placeholder={image.blur_ImageWideLarge}
                  />
                  {badge && badge.image !== undefined && (
                    <div className={styles.Badge}>
                      <img alt="" src={badge.image.Image} />
                    </div>
                  )}
                </CaseButton>

                <Caption
                  active={i === 0}
                  caseUrl={link}
                  logo={logo}
                  readyMagMobile={readyMagMobile}
                  slug={slug}
                  title={shortTitle}
                />
              </div>
            </SliderWrapper.Slide>
          )
        })
      }
      onInit={onInit}
    >
      {isMany && (
        <React.Fragment>
          <SliderWrapper.Pagination className={styles.Pagination} />
          <SliderWrapper.ArrowPrev className={styles.ArrowPrev} />
          <SliderWrapper.ArrowNext className={styles.ArrowNext} />
        </React.Fragment>
      )}
    </SliderWrapper>
  )
}
